import axiosClient, { HOST } from './axiosClient';

const forgotPasswordService = {
  getUsername: (username) =>
    axiosClient
      .get(`${HOST.USER_SERVICE}/admin-users/public/get-by-user-name?username=${username}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error)),
  changePassword: (data) =>
    axiosClient
      .post(`${HOST.USER_SERVICE}/admin-users/update-password`, data)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error)),
  getOTP: (email) =>
    axiosClient
      .post(`${HOST.USER_SERVICE}/admin-users/genotp-forgotpass?email=${email}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error)),
};

export default forgotPasswordService;
